(function () {
    'use strict';

    window.TabsSliderFactory = function (config) {
        const {
            sliderClass,
            prefix,
            swiperOptions = {}
        } = config;

        function initSlider(sliderEl) {
            if (!sliderEl || sliderEl.dataset[`${prefix}Initialized`] === 'true') return;

            const swiperEl = sliderEl.querySelector('.swiper');
            if (!swiperEl || typeof FoxTheme === 'undefined' || !FoxTheme.Carousel) return;

            const defaultOptions = {
                slidesPerView: 'auto',
                navigation: {
                    nextEl: sliderEl.querySelector('.swiper-button-next'),
                    prevEl: sliderEl.querySelector('.swiper-button-prev'),
                },
                pagination: {
                    el: sliderEl.querySelector('.swiper-pagination'),
                    type: 'progressbar',
                },
                watchSlidesProgress: true,
                observer: true,
                observeParents: true,
                mousewheel: {
                    forceToAxis: true,
                    releaseOnEdges: true,
                },
            };

            const mergedOptions = { ...defaultOptions, ...swiperOptions };
            const carousel = new FoxTheme.Carousel(swiperEl, mergedOptions, [FoxTheme.Swiper.Mousewheel]);

            carousel.init();
            sliderEl.dataset[`${prefix}Initialized`] = 'true';
            sliderEl[`_${prefix}CarouselInstance`] = carousel;

            setTimeout(() => {
                if (carousel.slider) carousel.slider.update();
            }, 200);
        }

        function initAll() {
            document.querySelectorAll(`.${sliderClass}`).forEach(slider => {
                initSlider(slider);
            });
        }

        function setupListeners() {
            document.querySelectorAll(`.${sliderClass}`).forEach(sliderEl => {
                const tabs = sliderEl.closest('tabs-component');
                if (tabs && !tabs.dataset[`${prefix}ListenerSet`]) {
                    tabs.addEventListener('tabChange', () => {
                        setTimeout(() => {
                            tabs.querySelectorAll(`.${sliderClass}`).forEach(slider => {
                                if (slider.dataset[`${prefix}Initialized`] !== 'true') {
                                    initSlider(slider);
                                } else if (slider[`_${prefix}CarouselInstance`]?.slider) {
                                    slider[`_${prefix}CarouselInstance`].slider.update();
                                }
                            });
                        }, 150);
                    });
                    tabs.dataset[`${prefix}ListenerSet`] = 'true';
                }
            });
        }

        function init() {
            initAll();
            setupListeners();
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', init);
        } else {
            setTimeout(init, 100);
        }

        return {
            init: initSlider,
            initAll: initAll
        };
    };
})();
